class GuitarSlider {
  constructor(container) {
    if (!container) {
      console.error('❌ No slider container found');
      return;
    }

    this.container = container;
    this.slides = Array.from(container.querySelectorAll('.guitar-slide'));
    this.indicators = Array.from(container.querySelectorAll('.slide-indicators .indicator'));
    this.prevButton = container.querySelector('.nav-button.prev');
    this.nextButton = container.querySelector('.nav-button.next');

    if (!this.slides.length || !this.prevButton || !this.nextButton) {
      console.error('❌ Required slider elements not found');
      return;
    }

    this.currentSlideIndex = 0;
    this.isTransitioning = false;

    this.init();
  }

  init() {
    this.slides.forEach((slide, index) => {
      if (index === 0) {
        slide.style.display = 'block';
        slide.classList.add('active');
        setTimeout(() => slide.style.opacity = '1', 50);
      } else {
        slide.style.display = 'none';
        slide.style.opacity = '0';
        slide.classList.remove('active');
      }
    });

    this.indicators.forEach((indicator, index) => {
      indicator.addEventListener('click', () => {
        if (!this.isTransitioning) {
          this.showSlide(index);
        }
      });
      if (index === 0) indicator.classList.add('active');
    });

    this.prevButton.addEventListener('click', () => {
      if (!this.isTransitioning) {
        let newIndex = this.currentSlideIndex === 0 ? this.slides.length - 1 : this.currentSlideIndex - 1;
        this.showSlide(newIndex);
      }
    });

    this.nextButton.addEventListener('click', () => {
      if (!this.isTransitioning) {
        let newIndex = this.currentSlideIndex === this.slides.length - 1 ? 0 : this.currentSlideIndex + 1;
        this.showSlide(newIndex);
      }
    });

    this.setupColorSelector();
  }

  async showSlide(index) {
    if (this.isTransitioning || index === this.currentSlideIndex) return;
    
    this.isTransitioning = true;

    const currentSlide = this.slides[this.currentSlideIndex];
    const nextSlide = this.slides[index];

    this.indicators[this.currentSlideIndex]?.classList.remove('active');
    this.indicators[index]?.classList.add('active');

    nextSlide.style.display = 'block';
    nextSlide.classList.add('active');
    nextSlide.offsetHeight;
    currentSlide.style.opacity = '0';
    nextSlide.style.opacity = '1';

    await new Promise(resolve => setTimeout(resolve, 500));

    currentSlide.style.display = 'none';
    currentSlide.classList.remove('active');

    this.currentSlideIndex = index;
    this.isTransitioning = false;
  }

  setupColorSelector() {
    this.slides.forEach(slide => {
      const colorButtons = slide.querySelectorAll('.color-button');
      const images = slide.querySelectorAll('.guitar-image');
      const colorNames = slide.querySelectorAll('[data-color-name]');

      colorButtons.forEach(button => {
        button.addEventListener('click', () => {
          colorButtons.forEach(btn => btn.classList.remove('active'));
          button.classList.add('active');

          const selectedColor = button.getAttribute('data-color');
          images.forEach(img => {
            img.style.display = img.getAttribute('data-color') === selectedColor ? 'block' : 'none';
          });

          const selectedTitle = button.getAttribute('title');
          colorNames.forEach(name => {
            name.style.display = name.getAttribute('data-color-name') === selectedTitle ? 'block' : 'none';
          });
        });
      });
    });
  }
}

// Initialize sliders
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('[data-slider]');
  sliders.forEach(slider => new GuitarSlider(slider));
});